import type { ReactNode } from "react";

import { cn } from "@/shared/lib/cn";

/** A keyboard key, always laid out left to right. */
export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      dir="ltr"
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded border border-line border-b-2 bg-surface px-1 font-sans text-[11.5px] font-semibold text-ink-subtle",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
